import React from 'react';
import PropTypes from 'prop-types';
import InlineFormField from 'wonderbly-components/lib/InlineFormField';
import Tooltip from 'wonderbly-components/lib/Tooltip';

const Locale = props => (
  <div className="locale">
    <Tooltip className="error-tooltip" visible={!!props.error} absolute={!props.tabletDown} type="alert">
      {props.error}
    </Tooltip>
    <InlineFormField
      id={props.id}
      label={props.label}
      fieldType="select"
      options={props.options}
      value={props.locale}
      onChange={props.onHandleChange}
    />
  </div>
);

Locale.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  onHandleChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  tabletDown: PropTypes.bool.isRequired
};

export default Locale;
